import { EdgelessClipboardConfig } from '@blocksuite/affine-block-surface';
import { type BlockSnapshot } from '@blocksuite/store';

import {
  createShardedDatabaseReferenceForHostDoc,
  ensureShardedDatabaseRootForHostDoc,
} from './data-source';

function hasMaterializedRowShards(snapshot: BlockSnapshot): boolean {
  const manifest = snapshot.props.databaseShardManifest;
  if (!manifest || typeof manifest !== 'object') return false;
  const shards = (manifest as { shards?: unknown }).shards;
  return Array.isArray(shards) && shards.length > 0;
}

export class EdgelessClipboardDatabaseConfig extends EdgelessClipboardConfig {
  static override readonly key = 'affine:database';

  override async createBlock(snapshot: BlockSnapshot): Promise<null | string> {
    const oldId = snapshot.id;

    if (hasMaterializedRowShards(snapshot)) {
      throw new Error(
        `Database block(id: ${oldId}) uses row shards; clipboard clone requires a bounded shard clone job`
      );
    }

    delete snapshot.props.index;
    const databaseReferenceProps = createShardedDatabaseReferenceForHostDoc(
      this.std.store
    );
    Object.assign(snapshot.props, databaseReferenceProps);
    if (!snapshot.props.xywh) {
      console.error(`Database block(id: ${oldId}) does not have xywh property`);
      return null;
    }

    const newId = await this.onBlockSnapshotPaste(
      snapshot,
      this.std.store,
      this.std.store.root!.id
    );
    if (!newId) {
      console.error(`Failed to paste database block(id: ${oldId})`);
      return null;
    }

    ensureShardedDatabaseRootForHostDoc(this.std.store, databaseReferenceProps);

    return newId;
  }
}
